// GeoIP data provider; its CC BY 4.0 licence requires this attribution + link wherever it is used.
export const GEOIP_ATTRIBUTION = {
  provider: 'DB-IP',
  url: 'https://db-ip.com',
} as const;
